import { graphql } from 'gql';

export const uerWorkOrderChangePriceItemsGql = graphql(`
    query uerWorkOrderChangePriceItems(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $where: WorkOrderChangePriceItemFilterInput
    ) {
        uerWorkOrderChangePriceItems(
            skip: $skip
            take: $take
            constructionTypeId: $constructionTypeId
            workOrderChangeId: $workOrderChangeId
            where: $where
        ) {
            totalCount
            items {
                calculatingType
                calculatingTypeValue
                chapter
                clientId
                code
                constructionTypeId
                entityTypeId
                entityTypeName
                entityTypeUniqueId
                entryId
                hasAcceptedCost
                hasDuplicates
                hasEmptySeasonVolume
                hasLimitSpan
                isActKC2Price
                isAddedPrice
                isBlockedPrice
                isExcludedPrice
                isOtherGroup
                isOtherItem
                isRootObject
                isSMRItem
                itemId
                name
                objectName
                rationale
                rootObjectName
                seasonValues {
                    workOrderPriceId
                    workOrderChangePriceId
                    workOrderSeasonId
                    workOrderChangeSeasonId
                    itemTip
                    seasonYear
                    planVolume
                    planTerms
                    planCost
                    completedVolume
                    completedCost
                    remainderVolume
                    remainderCost
                    hasErrors
                    errors
                }
                sortOtherPart
                sortPart
                sortSMRPart
                status
                statusTip
                totalCompletedCost
                totalCompletedVolume
                totalPlanCost
                totalPlanVolume
                totalRemainderCost
                totalRemainderVolume
                type
                uerCode
                uerCodeId
                uerId
                unit
                unitCost
                workCode
                workCompleted
                workInSum
                workKindWorkRatio
                workName
                workOrderChangeObjectId
                workOrderChangePriceId
                workOrderChangeRootObjectId
                workOrderObjectId
                workOrderRootObjectId
                workOrderPriceId
                workPlan
                workRatio
                workReminder
                workUnit
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemChapterFilterGql = graphql(`
    query uerWorkOrderChangePriceItemChapterFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfNullableOfChapterEnumFilterInput
    ) {
        uerWorkOrderChangePriceItemChapterFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemStatusFilterGql = graphql(`
    query uerWorkOrderChangePriceItemStatusFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput
    ) {
        uerWorkOrderChangePriceItemStatusFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemCodeFilterGql = graphql(`
    query uerWorkOrderChangePriceItemCodeFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput
    ) {
        uerWorkOrderChangePriceItemCodeFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value {
                    uerCodeId
                    uerCode
                    code
                    sortSMRPart
                    isUer
                    isRatio
                    isMtr
                }
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemNameFilterGql = graphql(`
    query uerWorkOrderChangePriceItemNameFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderChangePriceItemNameFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemUnitFilterGql = graphql(`
    query uerWorkOrderChangePriceItemUnitFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderChangePriceItemUnitFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemWorkInSumFilterGql = graphql(`
    query uerWorkOrderChangePriceItemWorkInSumFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfNullableOfWorkInSumEnumFilterInput
    ) {
        uerWorkOrderChangePriceItemWorkInSumFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangePriceItemWorkNameFilterGql = graphql(`
    query uerWorkOrderChangePriceItemWorkNameFilter(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $inputRootObject: WorkOrderChangeObjectIdInput
        $inputObject: WorkOrderChangeObjectIdInput
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderChangePriceItemWorkNameFilter(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            inputRootObject: $inputRootObject
            inputObject: $inputObject
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
